<template>
  <div class="at-Attribute_Wrapper">
    <div :class="`icon i-md pr-1 text-gray-500 ${icon}`"></div>
    <p class="text-sm mb-0 lh-1">
      <span>{{ value }}</span>
      <span v-if="subvalue">
        <br />
        <span class="font-weight-normal text-muted text-xs">{{ subvalue }}</span>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Attribute",
  props: {
    icon: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    subvalue: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
